import { ChartProps, Doughnut } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, ChartOptions, Legend, Tooltip } from 'chart.js';

import { CountryData } from '@/features/dashboard/types';
import { COLORS } from '@/shared/constants/colors';
import { numbers } from '@/shared/utils/numbers';

ChartJS.register(ArcElement, Tooltip, Legend);

export const DoughnutChart = ({
  countries,
  data,
}: {
  countries: Array<string>;
  data: CountryData[];
}) => {
  const total = data.reduce((result, currentValue) => result + currentValue.count, 0);
  const options: ChartOptions<'doughnut'> = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        callbacks: {
          title: () => '',
          beforeTitle: () => '',
          label: ({ dataIndex, label }) => {
            return [
              `Country: ${label}`,
              `Value: ${numbers.formatPrice(data[dataIndex].value)}`,
              `Percentage of Total Value: ${numbers.formatPercent({
                value: (data[dataIndex].count / total) * 100,
                withSign: true,
              })}`,
              `Asssets: ${data[dataIndex].count}`,
            ];
          },
        },
      },
    },
  };

  const chartData: ChartProps<'doughnut'>['data'] = {
    labels: countries,
    datasets: [
      {
        data: data.map((country) => country.count),
        backgroundColor: COLORS.chartColors,
        hoverOffset: 4,
      },
    ],
  };

  return <Doughnut data={chartData} options={options} />;
};
